import React, { useState } from "react";
import styles from "./FAQSection.module.css";
import { ChevronDown } from "lucide-react";

const FAQSection = ({ faqData }) => {
    const [openItems, setOpenItems] = useState([]);

    const toggleItem = (id) => {
        if (openItems.includes(id)) {
            setOpenItems(openItems.filter((item) => item !== id));
        } else {
            setOpenItems([...openItems, id]);
        }
    };

    let globalIndex = 0;

    return (
        <div className={styles.page}>
            <div className={styles.container}>
                {faqData.map((section, sectionIndex) => (
                    <div key={sectionIndex}>
                        <div className={styles.sectionTitle}>
                            {section.section.toUpperCase()}
                        </div>

                        {section.items.map((item) => {
                            const id = globalIndex++;
                            const isOpen = openItems.includes(id);

                            return (
                                <div key={id} className={styles.faqItem}>
                                    <div
                                        className={styles.question}
                                        onClick={() => toggleItem(id)}
                                    >
                                        <h3>{item.question}</h3>
                                        <ChevronDown
                                            size={20}
                                            className={`${styles.icon} ${isOpen ? styles.rotate : ""}`}
                                        />
                                    </div>

                                    <div
                                        className={`${styles.answer} ${isOpen ? styles.show : ""}`}
                                    >
                                        <p>{item.answer}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQSection;
